import { cn } from '@shared/lib/cn'
import type { CSSProperties, ReactNode } from 'react'

interface GlassCardProps {
  readonly children: ReactNode
  readonly className?: string
  readonly strong?: boolean
  readonly style?: CSSProperties
}

export function GlassCard({ children, className, strong = false, style }: GlassCardProps) {
  return (
    <div className={cn('rounded-2xl', strong ? 'glass-strong' : 'glass', className)} style={style}>
      {children}
    </div>
  )
}
